import { } from '@fortawesome//pro-solid-svg-icons';
import {
  faArrowTrendUp,
  faClipboardList,
  faDatabase,
  faTag,
  faTrophy,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowTrendUp as faArrowTrendUpSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as d3 from 'd3';
import { orderBy } from 'lodash';
import * as React from 'react';
import { ProjectGq } from '../../../../graphql/projects/models/ProjectGq';
import { QueuedItemStatus } from '../../../../graphql/projects/models/QueuedItemStatus';
import { formatNumber } from '../../../../logic/otherUtilities/formatting/formatNumber';
import VoxelTooltipShort from '../../../voxel/Tooltip/VoxelTooltipShort';

export interface ProjectTableStatsProps {
  project: ProjectGq;
}

const numberFormatter = d3.format('.1s');

const ProjectTableStats: React.FC<ProjectTableStatsProps> = ({ project }) => {
  const bgActiveColor = 'text-voxel-gray-600';
  const bgTrackingColor = 'text-success-500';
  const bgInactiveColor = 'text-voxel-gray-200';

  // Progress tracking - Completed tracking sessions
  const trackingRequests = orderBy(project?.projectSerpTrackingRequests, (pr) => pr.scheduledTime);
  const completedTrackingRequests = trackingRequests?.filter(
    (tr) => tr.status === QueuedItemStatus.SUCCEEDED
  );
  const hasProgressData = completedTrackingRequests.length >= 2;
  const progressIsOn = !!project.serpTrackingOn;

  return (
    <div className="w-48">
      <div className="flex flex-row items-center gap-4 flex-nowrap  justify-end">
        <div className="min-w-8">
          {project.progressKeywordCount > 10
            ? numberFormatter(project.progressKeywordCount)
            : project.progressKeywordCount > 0
              ? project.progressKeywordCount
              : ''}
        </div>
        <VoxelTooltipShort message={`${formatNumber(project?.progressKeywordCount ?? 0)} keywords`}>
          <FontAwesomeIcon
            icon={faDatabase}
            className={`${project.progressKeywordCount > 0 ? bgActiveColor : bgInactiveColor}`}
          />
        </VoxelTooltipShort>
        <VoxelTooltipShort message={`This project has tags`} disabled={!project.progressHasTags}>
          <FontAwesomeIcon
            icon={faTag}
            size="lg"
            className={`pt-[1px] -mr-[5px] ${project.progressHasTags ? bgActiveColor : bgInactiveColor
              }`}
          />
        </VoxelTooltipShort>
        <VoxelTooltipShort message={`This project has rank data`} disabled={!project.progressHasSerp}>
          <FontAwesomeIcon
            icon={faTrophy}
            className={`${project.progressHasSerp ? bgActiveColor : bgInactiveColor}`}
          />
        </VoxelTooltipShort>
        <VoxelTooltipShort
          message={`This project has a content plan`}
          disabled={!project.progressHasContentPlan}
        >
          <FontAwesomeIcon
            icon={faClipboardList}
            className={`${project.progressHasContentPlan ? bgActiveColor : bgInactiveColor}`}
          />
        </VoxelTooltipShort>
        <VoxelTooltipShort
          message={progressIsOn ? `Rank tracking is on` : `This project has rank tracking`}
          disabled={!(hasProgressData || progressIsOn)}
        >
          <FontAwesomeIcon
            icon={progressIsOn ? faArrowTrendUpSolid : faArrowTrendUp}
            className={`${progressIsOn ? bgTrackingColor : hasProgressData ? bgActiveColor : bgInactiveColor}`}
          />
        </VoxelTooltipShort>
      </div>
    </div>
  );
};

export default ProjectTableStats;
